export const LOGIN_PATH = '/login';
export const ALI_LOGIN_PATH = '/ali/login';
export const ALI_REGISTRATION_PATH = '/ali/registration';
export const REGISTRATION_PATH = '/registration';
export const ACTIVATION_REMINDER_PATH = '/activation-reminder';
export const HOME_PATH = '/home';
export const FORM_UPLOAD_BR_PATH = '/form_upload_br';
export const FEDEX_PATH = '/fedex';
